import React from "react";

export default function PopupModal({ show, onClose }) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br  bg-opacity-90 backdrop-blur-sm animate-fade-in">
      <div className="relative bg-white rounded-3xl shadow-[0_20px_60px_rgba(80,80,180,0.3)] border-4 border-indigo-200 p-10 max-w-lg w-full text-center overflow-hidden animate-scale-in">
        {/* Background Glow Animation */}
        <div className="absolute -inset-1 bg-gradient-to-r from-indigo-300 via-purple-300 to-blue-300 rounded-3xl blur-2xl opacity-30 z-[-1] animate-pulse" />
        {/* Glowing Logistics Icon */}
        <div className="flex justify-center mb-5">
          <div className="relative p-4 rounded-full bg-indigo-100 shadow-inner">
            <div className="absolute inset-0 rounded-full bg-indigo-300 blur-xl opacity-20 animate-ping"></div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-indigo-700 z-10 relative"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16V6a1 1 0 011-1h11a1 1 0 011 1v10m-2 4h2a2 2 0 002-2v-5h-6v5a2 2 0 002 2zM7 16a2 2 0 100 4 2 2 0 000-4zm10 0a2 2 0 100 4 2 2 0 000-4z"
              />
            </svg>
          </div>
        </div>
        {/* Main Heading */}
        <h2 className="text-4xl font-extrabold text-indigo-800 tracking-tight mb-3">
          Coming Soon!
        </h2>
        {/* Sub Text */}
        <p className="text-lg text-gray-600 font-medium mb-5 leading-relaxed">
          Our International Shipping Rate Calculator is on its way. 🚀
          <br />
          Get ready to explore global logistics with ease!
        </p>
        {/* Fancy CTA Button */}
        <button
          onClick={onClose}
          className="mt-4 px-6 py-3 text-white bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full font-semibold shadow-lg hover:scale-105 transform transition duration-300"
        >
          Got It!
        </button>
      </div>
    </div>
  );
}
